module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 79);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Align = __webpack_require__(80);

var _Align2 = _interopRequireDefault(_Align);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Align2.default;

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Align;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _general = __webpack_require__(81);

var _general2 = _interopRequireDefault(_general);

var _type = __webpack_require__(82);

var _type2 = _interopRequireDefault(_type);

var _typeS = __webpack_require__(83);

var _typeS2 = _interopRequireDefault(_typeS);

var _typeM = __webpack_require__(84);

var _typeM2 = _interopRequireDefault(_typeM);

var _typeL = __webpack_require__(85);

var _typeL2 = _interopRequireDefault(_typeL);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Use the Align component to align text, `inline` and `inline-block` elements.
 */
function Align(_ref) {
  var _cx, _cx2;

  var children = _ref.children,
      type = _ref.type,
      typeS = _ref.typeS,
      typeM = _ref.typeM,
      typeL = _ref.typeL;

  var isTable = type === 'top' || type === 'middle' || type === 'bottom';
  var isTableS = typeS === 'top' || typeS === 'middle' || typeS === 'bottom';
  var isTableM = typeM === 'top' || typeM === 'middle' || typeM === 'bottom';
  var isTableL = typeL === 'top' || typeL === 'middle' || typeL === 'bottom';

  var outerClasses = (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, _general2.default.table, isTable), _defineProperty(_cx, _general2.default.tableS, isTableS), _defineProperty(_cx, _general2.default.tableM, isTableM), _defineProperty(_cx, _general2.default.tableL, isTableL), _cx));

  var innerClasses = (0, _classnames2.default)(_type2.default[type], (_cx2 = {}, _defineProperty(_cx2, _typeS2.default[typeS], typeS), _defineProperty(_cx2, _typeM2.default[typeM], typeM), _defineProperty(_cx2, _typeL2.default[typeL], typeL), _cx2));

  return _react2.default.createElement(
    'div',
    { className: outerClasses },
    _react2.default.createElement(
      'div',
      { className: innerClasses },
      children
    )
  );
}

Align.propTypes = {
  children: _propTypes2.default.node.isRequired,
  type: _propTypes2.default.oneOf(['left', 'center', 'right', 'top', 'middle', 'bottom']),
  typeS: _propTypes2.default.oneOf(['left', 'center', 'right', 'top', 'middle', 'bottom']),
  typeM: _propTypes2.default.oneOf(['left', 'center', 'right', 'top', 'middle', 'bottom']),
  typeL: _propTypes2.default.oneOf(['left', 'center', 'right', 'top', 'middle', 'bottom'])
};

Align.defaultProps = {
  type: 'left'
};

/***/ }),

/***/ 81:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table":"general__table___3jJCK display-table height-100 width-100","tableS":"general__tableS___2_zai breakPointS-display-table breakPointS-height-100 breakPointS-width-100","tableM":"general__tableM___2XlIT breakPointM-display-table breakPointM-height-100 breakPointM-width-100","tableL":"general__tableL___1DXwW breakPointL-display-table breakPointL-height-100 breakPointL-width-100"};

/***/ }),

/***/ 82:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"left":"type__left___1wAb1 textAlign-left","center":"type__center___1qmwE textAlign-center","right":"type__right___256ff textAlign-right","top":"type__top___1WoGh display-tableCell verticalAlign-top","middle":"type__middle___2L7B5 display-tableCell verticalAlign-middle","bottom":"type__bottom___3MV5i display-tableCell verticalAlign-bottom"};

/***/ }),

/***/ 83:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"left":"typeS__left___3nN1x breakPointS-textAlign-left","center":"typeS__center___1DkX_ breakPointS-textAlign-center","right":"typeS__right___3RGlP breakPointS-textAlign-right","top":"typeS__top___1Tgpi breakPointS-display-tableCell breakPointS-verticalAlign-top","middle":"typeS__middle___2bZpr breakPointS-display-tableCell breakPointS-verticalAlign-middle","bottom":"typeS__bottom___2G_H1 breakPointS-display-tableCell breakPointS-verticalAlign-bottom"};

/***/ }),

/***/ 84:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"left":"typeM__left___3DSuw breakPointM-textAlign-left","center":"typeM__center___rmurE breakPointM-textAlign-center","right":"typeM__right___1AcHY breakPointM-textAlign-right","top":"typeM__top___1iEth breakPointM-display-tableCell breakPointM-verticalAlign-top","middle":"typeM__middle___2FND- breakPointM-display-tableCell breakPointM-verticalAlign-middle","bottom":"typeM__bottom___20IV5 breakPointM-display-tableCell breakPointM-verticalAlign-bottom"};

/***/ }),

/***/ 85:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"left":"typeL__left___X17zB breakPointL-textAlign-left","center":"typeL__center___2s8hv breakPointL-textAlign-center","right":"typeL__right___87tRJ breakPointL-textAlign-right","top":"typeL__top___2ogOh breakPointL-display-tableCell breakPointL-verticalAlign-top","middle":"typeL__middle___3moIl breakPointL-display-tableCell breakPointL-verticalAlign-middle","bottom":"typeL__bottom___1Yg_X breakPointL-display-tableCell breakPointL-verticalAlign-bottom"};

/***/ })

/******/ });
//# sourceMappingURL=marvel-ui-align.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@marvelapp/marvel-ui/lib/marvel-ui-align.js
// module id = 1098
// module chunks = 168707334958949